export default "__VITE_ASSET__CieBWrtF__"